import { SELECT_PATIENT, PATIENT_SELECTED, REMOVE_PATIENT, ERROR_FETCHING } from './types'

import { recommendationsActions, recommendationsTypes } from '../recommendations'
import { immunizationsActions, immunizationsTypes } from '../immunizations'
import { planActions, planTypes } from '../plan'
import {currentSelectionTypes} from '../currentSelection'
import { adverseReactionTypes } from '../adverseReactions'

import testPlan from '../../testData/testPlan'
import testPatients from '../../testData/testPatients'

export function selectPatient (patientId) {
  return dispatch => {
    dispatch({type: currentSelectionTypes.REMOVE_CURRENT_SELECTIONS})
    dispatch({type: SELECT_PATIENT, payload: patientId})
    setTimeout(function () {
      const currentPatient = testPatients.find(element => {
        return element.id === patientId
      })
      if (currentPatient) {
        dispatch({
          type: PATIENT_SELECTED,
          payload: {
            id: currentPatient.id,
            name: currentPatient.name,
            birthDate: currentPatient.birthDate,
            gender: currentPatient.gender,
            photo: currentPatient.photo,
            country: currentPatient.country
          }
        })
        if (!currentPatient.plan) {
          dispatch(planActions.setPlan(testPlan))
        } else {
          dispatch(planActions.setPlan(currentPatient.plan))
        }
        dispatch(immunizationsActions.setImmunizations(currentPatient.immunizations))
        if (!currentPatient.plan) {
          console.log('added default immuno')
          // dispatch(recommendationsActions.setRecommendations(testRecommendations))
        } else {
          dispatch(recommendationsActions.setRecommendations(currentPatient.recommendations))
        }
      } else {
        dispatch({type: ERROR_FETCHING})
      }
    }, 200)
  }
}

export function patientSelected (data) {
  return {
    type: PATIENT_SELECTED,
    payload: data
  }
}

export function removePatient () {
  return dispatch => {
    dispatch({
      type: REMOVE_PATIENT
    })
    dispatch({
      type: planTypes.REMOVE_PLAN
    })
    dispatch({
      type: recommendationsTypes.REMOVE_RECOMMENDATIONS
    })
    dispatch({
      type: immunizationsTypes.REMOVE_IMMUNIZATIONS
    })
    dispatch({
      type: adverseReactionTypes.REMOVE_ALL
    })
  }
}
